import { useMediaQuery } from "../hooks/responsive";
import { type Breakpoints } from "./slider";

export function getCurrentBreakpoint(breakpoints?: Breakpoints) {
    const breakpointsKeys = breakpoints
        ? Object.keys(breakpoints)
              .map(Number)
              .sort((a, b) => a - b)
        : [];
    const currentBreakpoints = breakpointsKeys.map((breakpoint) => {
        return {
            [breakpoint]: useMediaQuery(`(min-width: ${breakpoint}px)`),
        };
    });
    const lastTrueObj = [...currentBreakpoints].reverse().find((item) => Object.values(item)[0] === true);
    const currentBreakpoint = lastTrueObj ? Object.keys(lastTrueObj)[0] : null;
    return currentBreakpoint && breakpoints ? breakpoints[Number(currentBreakpoint)] : null;
}
